import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class MessageComposeService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }

  public InitComposeMessage() {
    return this.httpClient.get(`${this.rootUrl}/api/ComposeMessageApi/InitComposeMessage`);
  }

  public getRecipients() {
    return this.httpClient.get(`${this.rootUrl}/api/ComposeMessageApi/GetRecipients`);
  }

  public getAttachments() {
    return this.httpClient.get(`${this.rootUrl}/api/ComposeMessageApi/GetAttachments`);
  }

  public removeAttachment(name) {
    return this.httpClient.get(`${this.rootUrl}/api/ComposeMessageApi/RemoveAttachment?name=${name}`);
  }

  public sendMessage(message) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/ComposeMessageApi/SendMessage`, message, { headers });
  }

  public getMessage(message) {
    const headers = new HttpHeaders({ 'No-Auth': 'True' }).set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/ComposeMessageApi/ViewMessage`, message, { headers });
  }

  public downloadAttachment(message) {
    const headers = new HttpHeaders({ 'No-Auth': 'True' }).set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/ComposeMessageApi/DownloadAttachment`, message, { headers, responseType: 'blob' });
  }

  // public downloadAttachmentGet(message) {
  //   return this.httpClient.get(`${this.rootUrl}/api/ComposeMessageApi/DownloadAttachmentGet?m=${message.m}&g=${message.g}&c=${message.c}&f=${message.f}`, { responseType: 'blob' });
  // }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/message-compose.service.ts